$(document).on('click', 'a[data-save-link-state]', function (e) {
  history.pushState({}, '', $(this).attr('href'));
});

$(window).on('popstate', function () {
  $.get(document.location.href)
});